import { defineStore } from 'pinia';

export default defineStore('snackbar', () => {
  const visibility = ref(false);
  const message = ref('');
  const list = ref<string[]>([]);
  const timer = ref(-1);
  const color = ref<string | undefined>();
  const icon = ref<string | null>(null);
  const timeout = ref<ReturnType<typeof setTimeout> | null>(null);
  const actionLabel = ref('');
  const action = shallowRef<(() => void) | null>(null);

  const showSnackbar = (params: {
    text: string;
    items?: string[];
    state?: boolean | string | null;
    sign?: string | null;
    delay?: number;
    actionLabel?: string;
    action?: () => void;
  }) => {
    const {
      text = '',
      items = [],
      state = null,
      sign = null,
      delay = 3000,
    } = params;

    if (timeout.value) {
      clearTimeout(timeout.value);
    }

    visibility.value = true;
    message.value = text;
    list.value = items;
    actionLabel.value = params.actionLabel || '';
    action.value = params.action || null;

    if (typeof state === 'boolean') {
      color.value = state ? 'success' : 'error';
    } else if (state === null) {
      color.value = '#000';
    } else {
      color.value = state;
    }

    if (sign) {
      icon.value = sign;
    } else {
      switch (color.value) {
        case 'success':
          icon.value = 'mdi-checkbox-marked-circle-outline';
          break;
        case 'warning':
          icon.value = 'mdi-alert-outline';
          break;
        case 'error':
          icon.value = 'mdi-close-circle-outline';
          break;
        case 'info':
          icon.value = 'mdi-information-outline';
          break;
        default:
          icon.value = sign;
          break;
      }
    }

    // Set timeout to hide visibility
    if (delay !== -1) {
      timeout.value = setTimeout(() => {
        visibility.value = false;
      }, delay);
    }
  };

  const clearSnackbar = () => {
    if (timeout.value) {
      clearTimeout(timeout.value);
      timeout.value = null;
    }

    visibility.value = false;
    message.value = '';
    list.value = [];
    color.value = undefined;
    icon.value = null;
    actionLabel.value = '';
    action.value = null;
  };

  return {
    visibility,
    message,
    list,
    timer,
    color,
    icon,
    actionLabel,
    action,
    showSnackbar,
    clearSnackbar,
  };
});
